module.exports = __webpack_public_path__ + "static/media/JPG.2e9d0c5c.svg";